import React from 'react';
import { Icon } from 'semantic-ui-react';
import 'PointOfSale/styles/components/timeDelayComponent.less';
import PropTypes from 'prop-types';

const TimeDelayComponent = ({ seconds, increment, decrement }) => (
  <React.Fragment>
    <div className="text-primary delayLabel">Delay</div>
    <div className="text-primary secondsDiv">
      <span className={'numberCss'}>{seconds} </span>
      <span>seconds</span>
    </div>
    <div className="text-primary">
      <Icon
        name="minus circle"
        className="iconCss iconHeightWidth iconStyle"
        size="big"
        onClick={decrement}
      />
      <Icon
        name="plus circle"
        className="iconCss iconHeightWidth"
        size="big"
        onClick={increment}
      />
    </div>
  </React.Fragment>
);

TimeDelayComponent.propTypes = {
  seconds: PropTypes.number,
  increment: PropTypes.func,
  decrement: PropTypes.func
};
export default TimeDelayComponent;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/servingOptions/TimeDelayComponent.js